// import { faro } from '../index';
// import { LogLevel } from '@grafana/faro-react';
import logService from '@services/log-service';
import { LoggerMetaData } from 'interfaces/logger.interface';

  const additionalMessage = (
    message: string,
    loggerMetadata?: LoggerMetaData
  ) => {
    let merchantKey = '';
    let paymentCode = '';
    let tableNo = '';
    let referenceId = '';
    let qrToken = '';
    let spSessionId = '';
    if (loggerMetadata?.merchantKey)
      merchantKey = `|merchantKey=${loggerMetadata.merchantKey}`
    if (loggerMetadata?.paymentCode)
      paymentCode =`|paymentCode=${loggerMetadata.paymentCode}`
    if (loggerMetadata?.qrToken)
      qrToken = `|qrToken=${loggerMetadata.qrToken}`
    if (loggerMetadata?.referenceId)
      referenceId = `|referenceId=${loggerMetadata?.referenceId}`
    if (loggerMetadata?.tableNo)
      tableNo = `|tableNo=${loggerMetadata?.tableNo}`
    if (loggerMetadata?.spSessionId)
      spSessionId = `|spSessionId=${loggerMetadata?.spSessionId}`
  
    return `${message}${paymentCode}${merchantKey}${tableNo}${referenceId}${spSessionId}${qrToken}`
  }

export const info = (message: string,data?:any, loggerMetaData?: LoggerMetaData) => {
    try {
      // if(faro) {
      //   faro.api.pushLog([additionalMessage(message, loggerMetaData)], {
      //     context: data,
      //     level: LogLevel.INFO
      //   });
      // }
      logService.submitLog({
        message: additionalMessage(message, loggerMetaData), logData: {
          ...(data || {}),
          serviceContext: {
            url: window.location.href
          },
        },
        level: 'info'
      })

    } catch (e) { }
};
  
export const warn = (message: string,data?:any, loggerMetaData?: LoggerMetaData) => {
    try {
      // faro.api.pushLog([additionalMessage(message, loggerMetaData)], {
      //   context: data,
      //   level: LogLevel.WARN
      // });
      logService.submitLog({
        message: additionalMessage(message, loggerMetaData), logData: {
          ...(data || {}),
          serviceContext: {
            url: window.location.href
          },
        },
        level: 'warn'
      })
    } catch (e) { }
};
  
export const faroError = (message: string,data?:any, loggerMetaData?:LoggerMetaData) => {
    try {
      // faro.api.pushLog([additionalMessage(message, loggerMetaData)], {
      //   context: data,
      //   level: LogLevel.ERROR
      // })
      logService.submitLog({
        message: additionalMessage(message, loggerMetaData), logData: {
          ...(data || {}),
          serviceContext: {
            url: window.location.href
          },
        },
        level: 'error'
      })
    } catch (e) { }
};


  